import "@fontsource-variable/archivo/index.css";
import "@fontsource-variable/hanken-grotesk/index.css";
import "@fontsource-variable/spline-sans-mono/index.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { StatusApp } from "./status-app.js";
import "./styles/tokens.css";
import "./styles/global.css";

const root = document.getElementById("root");
if (!root) throw new Error("Status root is unavailable");

createRoot(root).render(
  <StrictMode>
    <StatusApp />
  </StrictMode>,
);
